import { Widget, WidgetHeader, WidgetBody } from "../../../ui/Widget"
import { useEffect, useState } from "react"
import useStore from "../../../../store"
import FieldAuditUnitRow from "./FieldAuditUnitRow"
import SearchBar from "../../../common/SearchBar"
import unitFilter from "../../../../utilities/unitFilter"
import { AccordionRoot } from "../../../ui/accordion"

export default function FieldAuditUnits({ fieldAuditId }) {
  const fetchFieldAuditUnits = useStore((state) => state.fetchFieldAuditUnits)
  const fieldAuditUnits = useStore((state) => state.fieldAuditUnits)

  const [fetchingFieldAuditUnits, setFetchingFieldAuditUnits] = useState(true)
  const [searchBarValue, setSearchBarValue] = useState('')
  const [filteredFieldAuditUnits, setFilteredFieldAuditUnits] = useState(fieldAuditUnits.data)
  const [openUnitId, setOpenUnitId] = useState([])

  useEffect(() => {
    fetchFieldAuditUnits(fieldAuditId,
      () => setFetchingFieldAuditUnits(false)
    )
  }, [])

  useEffect(() => {
    if (fieldAuditUnits?.data) {
      setFilteredFieldAuditUnits(unitFilter(fieldAuditUnits?.data, searchBarValue, true))
    }
  }, [searchBarValue, fieldAuditUnits])

  const handleRowClick = (id) => {
    if (openUnitId.includes(id)) {
      setOpenUnitId([])
    } else {
      setOpenUnitId([id])
    }
  }

  return(
    <Widget>
      <WidgetHeader title="Field Audit Units" showSpinner={fetchingFieldAuditUnits}>
        <SearchBar
          onChange={setSearchBarValue}
          value={searchBarValue}
          handleReset={() => setSearchBarValue('')}
        />
      </WidgetHeader>
      <WidgetBody
        isVisible={!fetchingFieldAuditUnits || Number(fieldAuditUnits['field_audit_id']) === Number(fieldAuditId)}
      >
        {fieldAuditUnits?.data?.length > 0 && filteredFieldAuditUnits?.length > 0 ?
          <AccordionRoot
            collapsible
            lazyMount
            unmountOnExit
            value={openUnitId}
            onValueChange={(e) => setOpenUnitId(e.value)}
          >
            {filteredFieldAuditUnits.map((fieldAuditUnit) => (
              <FieldAuditUnitRow
                key={fieldAuditUnit.id}
                fieldAuditUnit={fieldAuditUnit}
                fieldAuditId={fieldAuditId}
                handleClick={handleRowClick}
                filter={searchBarValue}
              />
            ))}
          </AccordionRoot>
        :
          <div className="text-center text-fpx-red mb-2">
            No Units to Audit
          </div>
        }
      </WidgetBody>
    </Widget>
  )
}